import { Link, useLocation } from "react-router-dom";
import Button from "../ui/button/button";
import { PATH } from "../../constants/navigation";
import { setConsent } from "./cookie-banner.utils";
import { useCookieBannerStore } from "../../store/cookieBannerStore";
import { useEffect } from "react";
import useScrollLock from "../../hooks/useScrollLock";
import { COOKIE_LOCAL_STORAGE_ID } from "../../constants/cookieBanner";

import "./cookie-banner.scss";

const CookieBanner = () => {
  const { isCBVisible, hideCookieBanner, showCookieBanner, setCBConsent } =
    useCookieBannerStore();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const isPolicyPage =
      path.includes(PATH.cookie) || path.includes(PATH.privacy);

    if (isPolicyPage) {
      hideCookieBanner();
    } else {
      const consent = localStorage.getItem(COOKIE_LOCAL_STORAGE_ID);
      if (!consent) showCookieBanner();
    }
  }, [location.pathname, showCookieBanner, hideCookieBanner]);

  useScrollLock(isCBVisible);

  const handleButtonClick = (value: "accepted" | "rejected") => {
    setConsent(value);
    setCBConsent(value === "accepted");
    hideCookieBanner();
  };

  return (
    <>
      {!!isCBVisible && (
        <div className="cookie-banner__overlay">
          <div
            className="cookie-banner"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cookie-banner-title"
          >
            <p className="cookie-banner__text">
              <span id="cookie-banner-title">
                Questo sito utilizza solo cookie tecnici e, previo consenso,
                cookie di terze parti.
              </span>
              <span>
                Usiamo i cookie tecnici per garantire il corretto funzionamento
                del sito.
              </span>
              <span>
                I cookie di terze parti vengono installati solo previo consenso,
                necessario per visualizzare mappe interattive di Google Maps.
              </span>
              <span>
                Puoi modificare in qualsiasi momento la tua scelta tramite il
                pulsante “Modifica le preferenze cookie” disponibile nel piè di
                pagina.
              </span>
            </p>
            <div className="cookie-banner__buttons">
              <Button
                text={"Accetta tutti i cookie"}
                type={"primary"}
                onClick={() => handleButtonClick("accepted")}
              />
              <Button
                text={"Rifiuta i cookie non necessari"}
                type={"secondary"}
                onClick={() => handleButtonClick("rejected")}
              />
            </div>
            <div className="cookie-banner__link-container">
              <Link className="cookie-banner__link" to={PATH.cookie}>
                Leggi la Cookie Policy
              </Link>
              <Link className="cookie-banner__link" to={PATH.privacy}>
                Leggi la Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
